import React from "react";
import * as Icons from "lucide-react";
import { abrirVisor } from "@/lib/visor";

// Abre el documento original en el visor de la app.
export const DocLink = ({ doc, testid }) => (
  <button data-testid={testid} onClick={() => abrirVisor(doc)}
    className="w-full flex items-center gap-2 bg-[#F6F3EE] hover:bg-[#EFE9DF] rounded-xl px-3 py-2.5 text-left transition-colors">
    <Icons.FileText size={17} className="text-[#3A6B56] shrink-0" />
    <span className="text-sm font-semibold text-[#1C2421] truncate flex-1">{doc.filename || doc.original_filename}</span>
    <Icons.ExternalLink size={15} className="text-[#9AA39D] shrink-0" />
  </button>
);
